import { TileRoleRoute } from '@/types'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'
import { faTicketSimple } from '@fortawesome/free-solid-svg-icons'

export const PiattaformaTicketRoute: TileRoleRoute = {
  path: 'piattaformaticket',
  text: 'Piattaforma Ticket',
  faIcon: faTicketSimple,
  element: (
    <ManagementGridFactory
      entity="piattaforma_ticket"
      referencesCollection={'tickets'}
      referencesTitle="Piattaforma Ticket"
      displayField="ded_Dis"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Piattaforma Ticket',
      icon: faTicketSimple,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
